import React, { useState, useEffect } from "react";
import { IoIosEye } from "react-icons/io";

import { toast, ToastContainer } from "react-toastify";
import {
  emailBodyImageUpload,
  CsvFileUpload,
  sendBulkEmailsForCampaign,
} from "proxyUrl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DataPreview from "./DataPreview";
import axios from "axios";
import { AiOutlineClose } from "react-icons/ai";
import EmailTempPreview from "./EmailTempPreview";
export default function Index() {
  const [content, setContent] = useState();
  const [preview, setPreview] = useState(null);
  const [csvFile, setCsvFile] = useState("");
  const [dataPre, setDataPre] = useState(false);
  const [tempPre, setTempPre] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [subject,setSubject] = useState("");
console.log(preview);
  const [allDataApi, setAllDataApi] = useState("");
  const [emailDataFromApi, setEmailDataApi] = useState("");
  const [csvSubmitted,setCsvSubmitted] = useState(false);

  const TemplateData = `
  <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Document</title>
  </head>
  <body>
  <style>
   img{
     
   }
    </style>
    ${content}
  </body>
  </html>
  `;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (!content) {
      toast.error(" Please Create a Email Template! ", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setSubmitted(false);
    } else if (!emailDataFromApi) {
      toast.error(" Please Upload Currect CSV file! ", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setSubmitted(false);
    } else {
      await axios
        .post(sendBulkEmailsForCampaign, {
          templateData: content ? content : "",
          emails: emailDataFromApi ? emailDataFromApi : "",
          subject:subject
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          const delay = () => {
            setSubmitted(false);
          };
          // eslint-disable-next-line
          const myTimeout = setTimeout(delay, 3000);
        });
    }
  };

  const handleTempPreview = () => {
    setTempPre(!tempPre);
  };
  const handleDataPreview = () => {
    setDataPre(!dataPre);
  };

  const handleImage = (e) => {
    setCsvFile(e.target.files[0]);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  const sendCsvFile = async () => {
    //creating form data
    setCsvSubmitted(true);
    const formData = new FormData();
    formData.append("csvfile", csvFile);

    await axios
      .post(CsvFileUpload, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (!res.data.data[0] || !res.data.email[0]) {
          setCsvSubmitted(false)
          toast.error("please upload currect CSV file!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        else{
          setCsvSubmitted(false)
          setAllDataApi(res.data.data);
          setEmailDataApi(res.data.email);
        }
      }).catch((err) =>{
       setCsvFile("");
        toast.error("cannot process file!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      })
  };

  useEffect(() => {
    setEmailDataApi("");
    setAllDataApi("");
    setCsvSubmitted(false)
  }, [csvFile]);
  return (
    <>
      <div className=" mt-7">
        <div className=" flex justify-between  gap-10 ">
          <div className=" input_btn h-30 w-1/2   rounded-lg bg-white py-3 px-6 shadow-md ">
            <h1 className="text-xl text-primaryBlue ">Choose CSV File</h1>
            <div className=" flex items-center justify-between  ">
              <input
                className="mt-10 pb-4  "
                id="fileSelect"
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleImage}
              />
              {csvFile ? (
               csvSubmitted ? (
                <button className="mt-8 rounded-md bg-green-600 px-3 py-1 text-white ">
                Processing...
              </button>
               ) : (
                allDataApi ? (
                  <button className="mt-8 rounded-md bg-green-600 px-3 py-1 text-white ">
                    Processed
                  </button>
                ) : (
                  <button
                    onClick={sendCsvFile}
                    className="mt-8 rounded-md bg-primaryBlue/70 px-3 py-1 text-white "
                  >
                    Process
                  </button>
                )
               )
              ) : (
                <button
                  disabled
                  className="mt-8 rounded-md bg-primaryBlue/70 px-3 py-1 text-white "
                >
                  Process
                </button>
              )}
            </div>
          </div>
          <div className=" input_btn h-30 flex w-1/2 flex-col  justify-between rounded-lg   bg-white py-4 px-6 shadow-md ">
            <div className=" flex items-center justify-between pb-2 ">
              <button
                className={`text-xl duration-300 ${
                  allDataApi ? `text-green-700` : ` text-red-300 `
                } `}
              >
                {" "}
                {allDataApi
                  ? "Data Prewiew available"
                  : "No Data Prewiew available"}{" "}
              </button>
              {allDataApi ? (
                <button
                  onClick={handleDataPreview}
                  className={`cursor-pointer rounded-md bg-primaryBlue px-2 text-3xl  text-white duration-200 hover:bg-primaryBlue/70 ${
                    dataPre ? `` : `disabled:`
                  }`}
                >
                  <IoIosEye />
                </button>
              ) : (
                <button
                  disabled
                  className={` rounded-md bg-primaryBlue/70 px-2 text-3xl  text-white duration-200 hover:bg-primaryBlue/70 ${
                    dataPre ? `` : `disabled:`
                  }`}
                >
                  <IoIosEye />
                </button>
              )}
            </div>
            
            <div className=" flex items-center justify-between pb-2 ">
              <button
                className={`text-xl duration-300 ${
                  content ? `text-green-700` : ` text-red-300 `
                } `}
              >
                {" "}
                {content
                  ? "Template Prewiew available"
                  : "No Template Prewiew available"}
              </button>
              {content ? (
                <button
                  onClick={handleTempPreview}
                  className=" cursor-pointer rounded-md bg-primaryBlue px-2 text-3xl  text-white duration-200 hover:bg-primaryBlue/70 "
                >
                  <IoIosEye />
                </button>
              ) : (
                <button className=" cursor-pointer rounded-md bg-primaryBlue/70 px-2 text-3xl  text-white duration-200 hover:bg-primaryBlue/70 ">
                  <IoIosEye />
                </button>
              )}
            </div>
          </div>
        </div>
        <h3 className="mt-5 text-xl ml-2 mb-2">Enter Mail Subject</h3>
        <div className=" mb-4  px-3 bg-white rounded-lg w-[48.5%] shadow-md ">
              <input onChange={(e)=>{
                setSubject(e.target.value)
              }} className=" focus:outline-none w-full h-full py-4" type="text" />
            </div>
        <div className="relative  mt-3 rounded-md bg-white p-4 shadow-md ">
          <h2 className="mb-1"> Content</h2>

          <CKEditor
            value={content}
            editor={ClassicEditor}
            onInit={(editor) => {
              //// Here the editor is ready to be used
            }}
            onChange={(handleInput, editor) => {
              const data = editor.getData();
              setContent(data);
            }}
            config={{
              // plugins: [ Essentials ],
              ckfinder: {

                // The URL that the images are uploaded to.
                uploadUrl: `${emailBodyImageUpload}`,

                // Enable the XMLHttpRequest.withCredentials property.
                withCredentials: true,

                // Headers sent along with the XMLHttpRequest to the upload server.
              },
            }}
          />
        </div>
       {
        submitted ? (
          <div className="mx-auto my-10 flex-col  flex items-center justify-center">
          {" "}
          <button
           disabled
            className=" rounded-md bg-primaryBlue/60 px-8 py-2 text-white shadow-md "
          >
            Loading...
          </button>
          
          <div className=" text-lg"> <span className="text-xl text-red-500" >Note</span> : It will take some time please do not refresh the page</div>
        
         </div>
        ) :(
          <div className="mx-auto  my-10 flex items-center justify-center">
          {" "}
          <button
            onClick={handleSubmit}
            className=" rounded-md bg-primaryBlue px-8 py-2 text-white shadow-md "
          >
            Submit
          </button> 
        </div>
        )
       }
    
      </div>
      <div
        className={`${
          dataPre ? `top-0 ` : `top-[100%] opacity-0`
        } fixed top-0 left-0 z-50 h-screen w-full   bg-[#000]/80 duration-300 `}
      >
        <div
          onClick={() => {
            setDataPre(!dataPre);
          }}
          className=" absolute top-10 right-10 w-fit cursor-pointer rounded-md border-2 border-white p-2 text-3xl text-white "
        >
          <AiOutlineClose />
        </div>
        <DataPreview data={allDataApi ? allDataApi : ""} />
      </div>
      <div
        className={`${
          tempPre ? `top-0 ` : `top-[100%] opacity-0`
        } fixed top-0 left-0 z-50 h-screen w-full   bg-[#000]/80 duration-300 `}
      >
        <div
          onClick={() => {
            setTempPre(!tempPre);
          }}
          className=" absolute top-10 right-10 w-fit cursor-pointer rounded-md border-2 border-white p-2 text-3xl text-white "
        >
          <AiOutlineClose />
        </div>
        <EmailTempPreview data={TemplateData} />
      </div>

      <ToastContainer />
    </>
  );
}
